import { styled } from '@linaria/react';
import { semantic, space } from '../../theme/tokens';

export const Bar = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  min-height: ${space['space-1200']};
  background: ${semantic.bg.canvas};

  & > button {
    left: 0;
  }
`;
